'use strict';

import { amountInWordsINR } from './ledger/shared';

const amountInWordsSimple = amountInWordsINR;

const pick = (apiProfile, sessionUser, apiKey, sessionKey) => {
  const fromApi = apiProfile?.[apiKey];
  if (fromApi != null && String(fromApi).trim() !== '') return String(fromApi).trim();
  const fromSession = sessionUser?.[sessionKey ?? apiKey];
  if (fromSession != null && String(fromSession).trim() !== '') return String(fromSession).trim();
  return '';
};

export function mapOwnerProfileForReceipt(apiProfile = {}, sessionUser = {}) {
  const holderName = pick(apiProfile, sessionUser, 'account_holder_name', 'name')
    || pick(apiProfile, sessionUser, 'name', 'name');
  const bankName = pick(apiProfile, sessionUser, 'bank_name');
  const accountNumber = pick(apiProfile, sessionUser, 'account_number', 'bank_account');
  const ifsc = pick(apiProfile, sessionUser, 'ifsc');
  const pan = pick(apiProfile, sessionUser, 'pan_number', 'pan');
  const gstin = pick(apiProfile, sessionUser, 'gstin');

  let bank = '—';
  if (bankName && accountNumber) bank = `${bankName}: ${accountNumber}`;
  else if (bankName) bank = bankName;
  else if (accountNumber) bank = accountNumber;

  return {
    name: holderName || '—',
    email: pick(apiProfile, sessionUser, 'email'),
    phone: pick(apiProfile, sessionUser, 'phone'),
    company: pick(apiProfile, sessionUser, 'company'),
    gstin,
    pan: pan || (gstin ? `GSTIN ${gstin}` : '—'),
    aadhaar: 'On file (KYC)',
    bank,
    ifsc: ifsc || '—',
    bank_name: bankName,
    account_number: accountNumber,
    account_holder_name: holderName,
    pan_number: pan,
  };
}

/** @deprecated use mapOwnerProfileForReceipt */
export function getOwnerProfileFromSession(sessionUser = {}) {
  return mapOwnerProfileForReceipt({}, sessionUser);
}

export function isOwnerProfileIncomplete(profile = {}) {
  return !String(profile.name || profile.account_holder_name || '').trim();
}

export function buildOwnerReceiptPayload(settlement, sessionUser = {}, apiProfile = {}) {
  const profile = mapOwnerProfileForReceipt(apiProfile, sessionUser);
  const gross = Number(settlement?.gross_amount || 0);
  const commission = Number(settlement?.commission_amount || 0);
  const tds = Number(settlement?.tds_amount || 0);
  const tcs = Number(settlement?.gst_tcs_amount || 0);
  const net = Number(settlement?.net_owner_amount || 0);
  const settledAt = settlement?.created_at || new Date().toISOString();
  const bookingRef = settlement?.booking_ref || settlement?.bookingRef || '—';
  const machine = settlement?.bookings?.machines || {};
  const commPct = gross > 0 ? Math.round((commission / gross) * 1000) / 10 : 15;

  const payDate = new Date(settledAt).toLocaleDateString('en-IN');
  const period = new Date(settledAt).toLocaleDateString('en-IN', { month: 'short', year: 'numeric' });
  const receiptYear = new Date(settledAt).getFullYear();
  const receiptNo = `DE/RCPT/OWN/${receiptYear}/${String(bookingRef).replace(/[^A-Za-z0-9]/g, '').slice(-12) || '000'}`;

  const status = String(settlement?.status || '').toLowerCase();

  return {
    useDbAmounts: true,
    settlementId: settlement?.id,
    bookingId: bookingRef,
    bookingRef,
    receiptNo,
    payDate,
    period,
    settledAt,
    status,
    ownerId: settlement?.owner_id,
    ownerName: profile.name,
    ownerPan: profile.pan,
    ownerAadhaar: profile.aadhaar,
    ownerBank: profile.bank,
    ownerIfsc: profile.ifsc,
    grossAmount: gross,
    finalBase: settlement?.bookings?.rate_per_hour > 0
      ? Math.round(
        Number(settlement?.bookings?.final_hours
          || settlement?.bookings?.booked_hours || 0)
          * Number(settlement?.bookings?.rate_per_hour) * 100
      ) / 100
      : Math.round(gross / 1.18 * 100) / 100,
    finalGst: Math.round((gross
      - (settlement?.bookings?.rate_per_hour > 0
        ? Math.round(
          Number(settlement?.bookings?.final_hours
            || settlement?.bookings?.booked_hours || 0)
            * Number(settlement?.bookings?.rate_per_hour) * 100
        ) / 100
        : Math.round(gross / 1.18 * 100) / 100)
      ) * 100) / 100,
    commissionAmount: commission,
    commissionPct: commPct,
    tdsAmount: tds,
    tcsAmount: tcs,
    gstTcsAmount: tcs,
    netAmount: net,
    netOwnerAmount: net,
    machineName: machine.name || machine.machine_id || '—',
    regNo: machine.reg_no || machine.machine_id || '—',
    machineType: machine.type || machine.name || '—',
    clientName: 'Client',
    workPeriod: payDate,
    words: amountInWordsSimple(net),
    hours: Number(
      settlement?.bookings?.final_hours
      || settlement?.bookings?.operator_actual_hours
      || settlement?.bookings?.booked_hours
      || 0
    ),
    ratePerHour: Number(
      settlement?.bookings?.rate_per_hour || 0
    ),
    paymentMode: 'Wallet Credit',
    paymentRef: settlement?.owner_credit_ref
      || (settlement?.id
        ? String(settlement.id).replace(/-/g, '').slice(0, 16).toUpperCase()
        : null)
      || String(bookingRef),
    walletDestination: 'Development Express Owner Wallet',
  };
}
